export const LOGO =
  "https://customer-assets.emergentagent.com/job_10febd9f-37d9-4310-ad74-a6564a0856a2/artifacts/m2o6wl7u_A_futuristic_SLA_MSLA_resin_printer_202606150240.jpeg";

export const HERO_VIDEO =
  "/hero-video.mp4";

export const CONTACT = {
  name: "Shamim Chaudhary (Blake)",
  email: "blake@renderlabhq.com",
  phone: "+91 88502 53204",
  phoneHref: "+918850253204",
  instagram: "https://www.instagram.com/renderlabhq/",
};

export const SERVICES = [
  {
    key: "video",
    icon: "Clapperboard",
    title: "Video Editing",
    copy: "Sharp cuts, clean pacing and color — edits crafted for retention and impact.",
  },
  {
    key: "images",
    icon: "Sparkles",
    title: "Realistic AI Images",
    copy: "Photoreal AI-generated imagery, art-directed to look indistinguishably real.",
  },
  {
    key: "motion",
    icon: "Orbit",
    title: "AI Motion Graphics",
    copy: "Fluid, dimensional motion design that gives brands a living signature.",
  },
  {
    key: "web",
    icon: "LayoutTemplate",
    title: "Cool Landing Pages",
    copy: "Custom, conversion-minded web design that feels premium from first scroll.",
  },
];

export const WORK = [
  {
    id: "w1",
    title: "Product Motion Study",
    category: "AI Motion Graphics",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_10febd9f-37d9-4310-ad74-a6564a0856a2/artifacts/agksr9qn_hf_20260616_053138_5d3a30dc-02ba-4bef-babb-b697fdbe1fb5%20%281%29.mp4",
  },
  {
    id: "w2",
    title: "Footwear Render Loop",
    category: "Realistic AI Images",
    type: "video",
    src: "/hero-video.mp4",
  },
  {
    id: "w3",
    title: "Cinematic Sequence",
    category: "Video Editing",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_10febd9f-37d9-4310-ad74-a6564a0856a2/artifacts/g7bbn8wp_hf_20260615_132900_6c377ec4-3c0c-4df0-82e5-ccb86e17b5dd.mp4",
  },
  {
    id: "w4",
    title: "Abstract Brand Film",
    category: "AI Motion Graphics",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_10febd9f-37d9-4310-ad74-a6564a0856a2/artifacts/lchede8p_hf_20260615_095611_dbe72b67-dab2-4bcb-b7d5-6a70adf103a7.mp4",
  },
];

// AI Imagery Showcase marquee — add more image URLs here anytime, the marquee
// auto-duplicates the set and keeps looping seamlessly.
export const IMAGERY = [
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/s2vf81kv_4AF72A20-4B81-4450-9E1C-2200E0681C91.png",
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/zw1rizmf_1ACD8A3D-24CC-4CD7-8CB4-C77DE1D97BA3.png",
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/ba9030ez_IMG_1398.PNG",
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/zvcw5vgl_03285E6A-6ACB-414B-A5A1-5BA5380C8438.png",
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/94knb0o8_IMG_7034.JPG",
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/na64pjwe_70CC0CA1-7F8F-4577-949E-1196EF4F4517.jpeg",
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/jpiyca8y_IMG_7031.JPG",
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/g2gq53yy_Iris%20Male%20Lifestyle%20%281%29.png",
  "https://customer-assets.emergentagent.com/job_creative-ai-studio-217/artifacts/ljc5xwvp_38D16AEB-661D-420A-8962-7800D1CBE194.png",
];
